import React from 'react';
import { withRouter, Route, Redirect } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { LOGIN } from './PageUrls';

class PrivateRoute extends React.Component {
  state = {
    loaded: false,
    isAuthenticated: false,
  };

  componentDidMount() {
    const { isAuthenticated } = this.state;
    const { history } = this.props;

    this.authenticate();
    this.unlisten = history.listen(() => {
      Auth.currentAuthenticatedUser()
        .then(() => null)
        .catch(() => {
          if (isAuthenticated) this.setState({ isAuthenticated: false });
        });
    });
  }

  componentWillUnmount() {
    this.unlisten();
  }

  authenticate() {
    const { history } = this.props;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        const groups = user.signInUserSession.idToken.payload['cognito:groups'];
        if (groups && groups.length > 0) {
          this.setState({ loaded: true, isAuthenticated: true });
        } else {
          // eslint-disable-next-line no-console
          console.error("Current user isn't part of a group.");
          Auth.signOut();
          history.push(LOGIN);
        }
      })
      .catch(() => history.push(LOGIN));
  }

  render() {
    const { component: Component, ...rest } = this.props;
    const { loaded, isAuthenticated } = this.state;
    if (!loaded) return null;
    return (
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: LOGIN,
              }}
            />
          )}
      />
    );
  }
}

export default withRouter(PrivateRoute);
